import React, { useState } from 'react';
import './DemoForm.css';

// 🔧 Replace with your deployed Apps Script Web App URL
const SHEETS_WEBAPP_URL = 'https://script.google.com/macros/s/AKfycbyXEFtYayRPSgcf65MrQ_EJ9ALj4Jq2_-yj8b886MNgvzyo-WMBLcISp-KfMMjSLo17/exec';

const DemoForm = () => {
  /* ---------- local state ---------- */
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [demoType, setDemoType] = useState('recall'); // recall | inbound
  const [status, setStatus] = useState('');

  /* ---------- utilities ---------- */
  const formatPhoneNumber = (input) => {
    const digits = input.replace(/\D/g, '');
    if (digits.length === 10) return digits;
    if (digits.length === 11 && digits.startsWith('1')) return digits.substring(1);
    return digits;
  };

  /* ---------- handlers ---------- */
  const handleSubmit = async (e) => {
    e.preventDefault();
    const digits = formatPhoneNumber(phone);
    if (digits.length !== 10) {
      setStatus('Please enter a valid 10‑digit phone number');
      return;
    }
    if (!name.trim()) {
      setStatus('Please enter a name');
      return;
    }

    const fullNumber = `+1${digits}`;

    setName('');
    setPhone('');
    setStatus('Form submitted successfully ✔');

    // 1️⃣  Persist to Google Sheets
    try {
        await fetch(SHEETS_WEBAPP_URL, {
            method: 'POST',
            mode:   'no-cors',                  // ⬅️ prevents the browser from sending OPTIONS
            headers: { 'Content-Type': 'text/plain' }, // ⬅️ “simple” header → no pre-flight
            body: JSON.stringify({
                timestamp: new Date().toISOString(),
                name,
                phone: fullNumber,
                demoType,
            }),
        });
    } catch (err) {
      console.error('Sheets error:', err);
    }

    // 2️⃣  Trigger Azure function (skip for inbound) 123
    if (demoType !== 'inbound') {
      try {
        const response = await fetch(
          'https://newtonai2025.azurewebsites.net/api/DemoTriggerFunction',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              patient_name: name,
              phone_number: fullNumber,
              use_outbound_demo: demoType === 'recall',
            }),
          }
        );
        const result = await response.json();
        console.log("function call result ", result)
        if (!response.ok || !result.success) {
          setStatus(`Warning: Azure error – ${result.message || 'unknown'}`);
        }
      } catch (err) {
        setStatus(`Warning: Azure error – ${err.message}`);
      }
    }

    // 3️⃣  Done!
    setDemoType('recall');
  };

  /* ---------- render ---------- */
  return (
    <div className="demo-form-container">
      <h1 className="demo-title">Demo Form</h1>
      <form className="demo-form" onSubmit={handleSubmit}>
        <label>
          Name:
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter name"
            required
          />
        </label>

        <label>
          Phone Number:
          <input
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="10‑digit phone number"
            required
          />
        </label>

        <label>
          Demo Type:
          <select value={demoType} onChange={(e) => setDemoType(e.target.value)}>
            <option value="recall">Recall</option>
            <option value="inbound">Inbound</option>
          </select>
        </label>

        <button type="submit" className="demo-submit-btn">
          Submit
        </button>
      </form>
      {status && <p className="demo-status">{status}</p>}
    </div>
  );
};

export default DemoForm;

